(function () {
  if (window.__ulishCartToast) return;
  window.__ulishCartToast = true;

  /* ── Styles ──────────────────────────────────────────────────────────── */
  const CSS = `
    #ulish-cart-toast {
      position: fixed;
      bottom: -320px;
      left: 12px;
      right: 12px;
      max-width: 480px;
      margin: 0 auto;
      background: var(--color-background, #fff);
      border-radius: 20px;
      box-shadow:
        0 -2px 0 rgba(0,0,0,0.06) inset,
        0 8px 32px rgba(0,0,0,0.13),
        0 2px 8px rgba(0,0,0,0.06);
      padding: 0 20px 20px;
      z-index: 10000;
      transition: bottom 0.42s cubic-bezier(0.34, 1.3, 0.64, 1);
      font-family: var(--font-body-family, sans-serif);
    }
    #ulish-cart-toast.uct-visible { bottom: 20px; }

    .uct-handle {
      width: 34px; height: 4px;
      background: rgb(var(--color-foreground-rgb, 26 26 26) / 0.12);
      border-radius: 2px;
      margin: 14px auto 18px;
    }
    .uct-close {
      position: absolute;
      top: 16px; right: 16px;
      width: 28px; height: 28px;
      border-radius: 50%;
      background: rgb(var(--color-foreground-rgb, 26 26 26) / 0.07);
      border: none; cursor: pointer;
      font-size: 15px;
      color: rgb(var(--color-foreground-rgb, 26 26 26) / 0.5);
      display: flex; align-items: center; justify-content: center;
      padding: 0; line-height: 1;
    }
    .uct-close:hover { background: rgb(var(--color-foreground-rgb, 26 26 26) / 0.12); }

    .uct-header {
      display: flex; align-items: center; gap: 10px;
      margin-bottom: 14px;
    }
    .uct-check {
      width: 22px; height: 22px;
      background: #34A853; border-radius: 50%;
      flex-shrink: 0; position: relative;
    }
    .uct-check::after {
      content: '';
      position: absolute;
      left: 50%; top: 48%;
      width: 5px; height: 9px;
      border-right: 2px solid white;
      border-bottom: 2px solid white;
      transform: translate(-50%, -50%) rotate(45deg);
    }
    .uct-added-label {
      font-size: 14px; font-weight: 600;
      color: var(--color-foreground, #1a1a1a);
      letter-spacing: 0.01em;
    }

    .uct-product {
      display: flex; gap: 14px; align-items: center;
      margin-bottom: 14px;
    }
    .uct-thumb {
      width: 66px; height: 66px;
      border-radius: 10px; object-fit: cover;
      background: rgb(var(--color-foreground-rgb, 26 26 26) / 0.05);
      flex-shrink: 0;
    }
    .uct-info { flex: 1; min-width: 0; }
    .uct-name {
      font-size: 13px; font-weight: 600;
      color: var(--color-foreground, #1a1a1a);
      margin: 0 0 3px; white-space: nowrap;
      overflow: hidden; text-overflow: ellipsis;
    }
    .uct-variant-label {
      font-size: 12px;
      color: rgb(var(--color-foreground-rgb, 26 26 26) / 0.5);
      margin: 0 0 5px;
    }
    .uct-item-price {
      font-size: 15px; font-weight: 700;
      color: var(--color-foreground, #1a1a1a);
      margin: 0;
    }

    .uct-sep {
      height: 1px;
      background: rgb(var(--color-foreground-rgb, 26 26 26) / 0.08);
      margin-bottom: 13px;
    }
    .uct-subtotal {
      display: flex; justify-content: space-between; align-items: baseline;
      font-size: 13px;
      color: rgb(var(--color-foreground-rgb, 26 26 26) / 0.55);
      margin-bottom: 14px;
    }
    .uct-total { font-size: 16px; font-weight: 700; color: var(--color-foreground, #1a1a1a); }

    .uct-cta {
      display: flex; align-items: center; justify-content: center; gap: 6px;
      width: 100%; padding: 15px;
      background: #E8793A;
      color: #fff !important;
      text-decoration: none !important;
      border-radius: var(--style-border-radius-buttons, 12px);
      font-size: 15px; font-weight: 700;
      letter-spacing: 0.02em;
      border: none; cursor: pointer;
      transition: filter 0.18s;
      margin-bottom: 11px;
    }
    .uct-cta:hover { filter: brightness(1.06); }
    .uct-cta-arrow { font-size: 17px; line-height: 1; }

    .uct-keep {
      display: block; width: 100%;
      background: none; border: none; cursor: pointer;
      font-size: 12px;
      color: rgb(var(--color-foreground-rgb, 26 26 26) / 0.45);
      text-decoration: underline;
      text-underline-offset: 3px;
      padding: 4px;
      font-family: inherit;
    }
    .uct-keep:hover { color: rgb(var(--color-foreground-rgb, 26 26 26) / 0.7); }
  `;

  const styleEl = document.createElement('style');
  styleEl.textContent = CSS;
  document.head.appendChild(styleEl);

  /* ── Markup ──────────────────────────────────────────────────────────── */
  const el = document.createElement('div');
  el.id = 'ulish-cart-toast';
  el.setAttribute('aria-live', 'polite');
  el.innerHTML = `
    <div class="uct-handle"></div>
    <button class="uct-close" aria-label="閉じる">&#x2715;</button>
    <div class="uct-header">
      <span class="uct-check" aria-hidden="true"></span>
      <span class="uct-added-label">カートに追加しました</span>
    </div>
    <div class="uct-product">
      <img class="uct-thumb" src="" alt="" width="66" height="66">
      <div class="uct-info">
        <p class="uct-name"></p>
        <p class="uct-variant-label"></p>
        <p class="uct-item-price"></p>
      </div>
    </div>
    <div class="uct-sep"></div>
    <div class="uct-subtotal">
      <span>小計</span>
      <span class="uct-total"></span>
    </div>
    <a href="/checkout" class="uct-cta">
      <span>購入情報入力画面に進む</span>
      <span class="uct-cta-arrow">&#x2192;</span>
    </a>
    <button class="uct-keep">お買い物を続ける</button>
  `;
  document.body.appendChild(el);

  /* ── Logic ───────────────────────────────────────────────────────────── */
  let hideTimer;

  function fmtPrice(cents) {
    return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
  }

  function showToast(item) {
    // Product thumb
    const thumb = el.querySelector('.uct-thumb');
    thumb.src = item.image ? item.image.replace(/\?.*$/, '') + '?width=132' : '';
    thumb.alt = item.product_title || '';

    // Name & variant
    el.querySelector('.uct-name').textContent = item.product_title || '';
    const vt = item.variant_title;
    el.querySelector('.uct-variant-label').textContent =
      (vt && vt !== 'Default Title') ? vt : '';
    el.querySelector('.uct-item-price').textContent = fmtPrice(item.final_price);

    // Cart subtotal
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        el.querySelector('.uct-total').textContent = fmtPrice(cart.total_price);
      })
      .catch(() => {
        el.querySelector('.uct-total').textContent = fmtPrice(item.final_price);
      });

    // Show
    requestAnimationFrame(() => { el.classList.add('uct-visible'); });
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hideToast, 7000);
  }

  function hideToast() {
    el.classList.remove('uct-visible');
    clearTimeout(hideTimer);
  }

  el.querySelector('.uct-close').addEventListener('click', hideToast);
  el.querySelector('.uct-keep').addEventListener('click', hideToast);

  /* ── Fetch interceptor ───────────────────────────────────────────────── */
  const origFetch = window.fetch;
  window.fetch = function (...args) {
    const url = (typeof args[0] === 'string' ? args[0] : args[0]?.url) || '';
    const isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);

    return origFetch.apply(this, args).then(res => {
      if (isAdd && res.ok) {
        res.clone().json().then(data => {
          // If redirecting to checkout right after (LP flow), skip toast
          if (window.__ulishSkipToast) return;
          const item = Array.isArray(data.items) ? data.items[0] : data;
          if (item && item.product_title) showToast(item);
        }).catch(() => {});
      }
      return res;
    });
  };
})();
